// removed by extract-text-webpack-plugin
module.exports = {"btn":"btn-_PomU btn-3FsRe"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/settings/style.scss
 ** module id = 199
 ** module chunks = 0
 **/